/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { type Dispatch, createContext, useReducer } from 'react'

import { type ViewLikesContextAction } from './dispatchTypes'
import { ViewLikesContextReducer } from './reducer'
import { ViewLikesContextInitialState } from './state'
import { type IViewLikesContextState } from './types'
import { type IProps } from './ViewLikesContext.types'

export const ViewLikesContext = createContext<{
    state: IViewLikesContextState
}>({
    state: ViewLikesContextInitialState
})

let persistantDispatch: React.Dispatch<ViewLikesContextAction>

export const ViewLikesContextProvider = ({ children, postId }: IProps) => {
    const [state, dispatch] = useReducer(
        ViewLikesContextReducer as React.Reducer<
            IViewLikesContextState,
            ViewLikesContextAction
        >,
        { ...ViewLikesContextInitialState, postId }
    )
    persistantDispatch = dispatch

    return (
        <ViewLikesContext.Provider value={{ state }}>
            {children}
        </ViewLikesContext.Provider>
    )
}

export const useViewLikesDispatch = () => persistantDispatch
